import React from 'react';
import deviceStatus from 'propTypes/deviceStatus';
import styles from './device-status-text.scss';

function mapStatusToText(status) {
  switch (status) {
    case 'ok':
      return 'OK';
    case 'warning':
      return 'Warning';
    case 'disconnected':
      return 'Disconnected';
    default:
      return `Unknown status: ${status}`;
  }
}

const DeviceStatusText = ({ status }) =>
  <span className={styles[`status-${status}`]}>
    {mapStatusToText(status)}
  </span>;

DeviceStatusText.propTypes = {
  status: deviceStatus.isRequired,
};

export default DeviceStatusText;



// WEBPACK FOOTER //
// ./src/components/DeviceStatusText/index.js